var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 453.385,
    height: 453.385,
    style: {
      enableBackground: "new 0 0 453.385 453.385"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.929 122.287a4.834 4.834 0 0 1-.97 2.888 4.777 4.777 0 0 1-5.592 1.572l-59.805-23.616v345.455a4.8 4.8 0 0 1-4.8 4.799h-47.925a4.797 4.797 0 0 1-4.799-4.799v-121.19l-.127.048v-.585c-38.873 26.592-84.217 34.471-87.527 35.021l-8.928-53.741c.907-.153 84.438-15.014 96.582-68.233V103.125l-59.808 23.616a4.783 4.783 0 0 1-5.592-1.572 4.79 4.79 0 0 1 .024-5.805L238.006 1.87A4.77 4.77 0 0 1 241.8 0c1.49 0 2.896.686 3.795 1.87l90.341 117.494c.661.866.993 1.895.993 2.923z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b23339",
      stroke: "#b23339",
      strokeWidth: 0.571014,
      fillOpacity: 1
    },
    d: "M216.7 452.788c-.941-.287-2.033-.962-2.426-1.5-.562-.767-.715-14.153-.715-62.503 0-33.84-.198-61.65-.441-61.8-.243-.15-3.113 1.408-6.378 3.463-16.505 10.384-38.292 19.847-60.01 26.066-7.866 2.252-20.547 5.117-20.935 4.73-.429-.43-8.938-52.315-8.63-52.623.162-.162 3.48-1.071 7.374-2.02 28.688-6.992 53.756-19.296 68.763-33.75 9.833-9.47 15.014-17.22 18.512-27.685l1.745-5.223v-68.58c0-37.72-.126-68.58-.28-68.58-.155 0-13.941 5.396-30.636 11.99-16.695 6.596-30.815 11.992-31.378 11.992-1.792 0-4.134-2.498-4.134-4.41 0-1.424 8.19-12.395 45.572-61.046 25.065-32.62 45.97-59.632 46.457-60.024 1.21-.977 4.396-.9 5.427.132.465.465 21.315 27.455 46.332 59.977 49.205 63.967 47.316 61.22 44.038 64.039-.852.733-2.022 1.332-2.601 1.332-.579 0-14.711-5.396-31.405-11.991-16.693-6.595-30.466-11.992-30.607-11.992-.14 0-.254 78.199-.254 173.775V450.33l-1.473 1.384-1.473 1.384-24.366.106c-13.446.058-25.133-.129-26.078-.417z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.eda1f4f372574031ac8c9a48d2c2db1b.svg";
export { ForwardRef as ReactComponent };